const paySettlementStatus = {
  GENERATED: 'GENERATED',
  ERP_RETURN_CREATED: 'ERP_RETURN_CREATED',
  ERP_CN_ISSUED: 'ERP_CN_ISSUED',
  ERP_INVOICE_SETTLED: 'ERP_INVOICE_SETTLED',
};

const paySettlementHeaders = {
  validHeader: {
    'Material Invoice Number*': 'material_invoice_number',
  },
};

module.exports = {
  paySettlementStatus,
  paySettlementHeaders
};